import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../../actions/index';

// import data from '../../data/modal.json';
// import Header from '../Header/Header';

import './Modal.css';

const Modal = props => (
  <section className="modal">
    <section className="modal__inner">
      <section className="modal__header">
        <h2 className="modal__title">{props.modal.title || ''}</h2>
        <button className="modal__back" onClick={() => props.setModal(null)}>
          Close
        </button>
      </section>
      <section className="modal__content">
        <iframe title={props.modal.title} src={props.modal.content} width="100%" height="100%" />
      </section>
    </section>
  </section>
);

function mapDispatchToProps(dispatch) {
  return {
    setModal: (index) => {
      dispatch(actions.setModal(index));
    },
  };
}

function mapStateToProps(state) {
  return {
    modal: state.navigation.modal,
  };
}

Modal.propTypes = {
  setModal: propTypes.func.isRequired,
  modal: propTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);




// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js